import { render, staticRenderFns } from "./NxSigningModalMergeDocBatch.vue?vue&type=template&id=2b7dd43a&scoped=true&"
import script from "./NxSigningModalMergeDocBatch.vue?vue&type=script&lang=js&"
export * from "./NxSigningModalMergeDocBatch.vue?vue&type=script&lang=js&"
import style0 from "./NxSigningModalMergeDocBatch.vue?vue&type=style&index=0&id=2b7dd43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7dd43a",
  null
  
)

export default component.exports